import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  ramais: [{}],
  ramalSelecionado: {},
  troncosDisponiveis: [],
  rotasDisponiveis: [],
  grupos: [],
  gruposDeRotas: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
